import React from 'react';
import './Navbar.css';
import logo from '../asset/icons/logo.svg';

const Navbar = () => {
  return (
    <nav className="navbar" role="navigation">
      <div className="container navbar-container">
        <div className="navbar-links navbar-links-left">
          <div className="nav-link-wrapper"><a href="#competenze" className="nav-link">Competenze</a></div>
          <div className="nav-link-wrapper"><a href="#chi-sono" className="nav-link">Chi sono</a></div>
        </div>
        <div className="logo-container">
          <img src={logo} alt="Sara Bocca Restauri Logo" className="logo" />
        </div>
        <div className="navbar-links navbar-links-right">
          <div className="nav-link-wrapper"><a href="#lavori" className="nav-link">Selezione lavori</a></div>
          <div className="nav-link-wrapper"><a href="#prima-dopo" className="nav-link">Prima e dopo</a></div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar; 